"use strict";

exports.__esModule = true;
exports.EditableGridElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _ElementEditorContextMenu = require("../../ConfigurableLayout/ElementEditor/ElementEditorContextMenu");
var _EditableGridCellWrapper = require("./EditableGridCellWrapper");
var _EditableGridElementLayer = require("./EditableGridElementLayer");
var _gridUtils = require("./gridUtils");
var _excluded = ["rowCount", "columnCount", "width", "height", "children"];
var _dec, _class, _EditableGridElement;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays an editable grid.
 */
var EditableGridElement = exports.EditableGridElement = (_dec = _ConfigurableLayout.ElementEditorContext.withContext, (0, _reactIntl.injectIntl)(_class = _dec(_class = (_EditableGridElement = /*#__PURE__*/function (_Component) {
  function EditableGridElement() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      highlightedCells: undefined
    };
    _this.handleHover = function (highlightedCells) {
      if (!_this.state.highlightedCells) {
        _this.setState({
          highlightedCells: highlightedCells
        });
        return;
      }
      var _this$state$highlight = _this.state.highlightedCells,
        gridRowStart = _this$state$highlight.gridRowStart,
        gridRowEnd = _this$state$highlight.gridRowEnd,
        gridColumnStart = _this$state$highlight.gridColumnStart,
        gridColumnEnd = _this$state$highlight.gridColumnEnd;
      if (highlightedCells.gridRowStart !== gridRowStart || highlightedCells.gridRowEnd !== gridRowEnd || highlightedCells.gridColumnStart !== gridColumnStart || highlightedCells.gridColumnEnd !== gridColumnEnd) {
        _this.setState({
          highlightedCells: highlightedCells
        });
      }
    };
    _this.handleContextMenu = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var _this$props = _this.props,
        path = _this$props.path,
        elementEditor = _this$props.elementEditor,
        intl = _this$props.intl;
      var menu = /*#__PURE__*/_react["default"].createElement(_ElementEditorContextMenu.ElementEditorContextMenu, {
        path: path,
        elementEditor: elementEditor,
        intl: intl
      });
      (0, _core.showContextMenu)({
        content: menu,
        targetOffset: {
          left: e.clientX,
          top: e.clientY
        }
      });
    };
    return _this;
  }
  _inheritsLoose(EditableGridElement, _Component);
  var _proto = EditableGridElement.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      rowCount = _this$props2.rowCount,
      columnCount = _this$props2.columnCount,
      width = _this$props2.width,
      height = _this$props2.height,
      children = _this$props2.children,
      extra = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_EditableGridElementLayer.EditableGridElementLayer, _extends({
      rowCount: rowCount,
      columnCount: columnCount,
      width: width,
      height: height
    }, extra, {
      onHover: this.handleHover,
      onContextMenu: this.handleContextMenu,
      highlightedCells: this.state.highlightedCells
    }), children.map(function (child, index) {
      return _this2.renderChild(child, index);
    }));
  };
  _proto.renderChild = function renderChild(child, index) {
    var _this$props3 = this.props,
      render = _this$props3.render,
      path = _this$props3.path;
    var _getGridCellDimension = (0, _gridUtils.getGridCellDimensions)(this.props, child.props),
      x = _getGridCellDimension.x,
      y = _getGridCellDimension.y,
      width = _getGridCellDimension.width,
      height = _getGridCellDimension.height;
    return /*#__PURE__*/_react["default"].createElement(_EditableGridCellWrapper.EditableGridCellWrapper, {
      key: String(index),
      element: Object.assign({}, child, {
        props: Object.assign({}, child.props, {
          x: x,
          y: y,
          width: width,
          height: height
        })
      }),
      grid: this.props,
      path: path.concat("children", index),
      onHover: this.handleHover,
      render: render,
      index: index
    }, child.children);
  };
  return EditableGridElement;
}(_react.Component), _EditableGridElement.defaultProps = {
  intl: undefined,
  elementEditor: undefined,
  rowCount: 12,
  columnCount: 12,
  padding: 0
}, _EditableGridElement)) || _class) || _class);